import { memo, useState } from "react";
import { IoEllipsisHorizontal } from "react-icons/io5";
import styled from "styled-components";
import { Element_Base } from "~/common/typescript/models/Element";
import MapUtils from "~/components/Map/utils/MapUtils";
import { ElementPanelUtil } from "~/layouts/components/Header/HeaderCenter/Element/ElementPanelUtil";
import { showElementDetailPanelAtom } from "~/components/Map/stores/mapStore";
import { useAtom } from 'jotai';
import { selectedElementAtom } from "~/components/Map/Element/ElementStore";
import { Popover } from "antd";
import ElementItemContextMenu from "./ElementItemContextMenu";
import { ElementItemUtil } from "./ElementItemUtil";

export interface ElementItemProps {
  element: Element_Base;
}

const ElementItem = (props: ElementItemProps) => {
  const { element } = props;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [showElementDetailPanel, setShowElementDetailPanel] = useAtom(showElementDetailPanelAtom);
  const [selectedElement, setSelectedElement] = useAtom(selectedElementAtom);

  const onClickItem = () => {
    ElementItemUtil.zoomToElement(element);
    setSelectedElement(element);
    setShowElementDetailPanel(true);
  }
  const onClickEdit = () => {
    setSelectedElement(element);
    setShowElementDetailPanel(true);
  }
  return <UI_Wrapper onDoubleClick={onClickItem}>
    <UI_Item_Icon>{ElementPanelUtil.getIcon(element.type)}</UI_Item_Icon>
    <UI_Item_Name>{element.name || `Chưa đặt tên ${element.uuid.slice(-7, -1)}`}</UI_Item_Name>
    <UI_Item_Right className="element-item-right">
      <Popover open={isPopoverOpen} trigger="click" placement="bottomLeft" title={null} arrow={false}
        content={<ElementItemContextMenu element={element} onClickEdit={() => onClickEdit()}
          onCloseContextMenu={() => setIsPopoverOpen(false)}
        />}>
        <IoEllipsisHorizontal onClick={() => setIsPopoverOpen(!isPopoverOpen)} />
      </Popover>
    </UI_Item_Right>
  </UI_Wrapper>;
};

export default memo(ElementItem);

const UI_Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: #f0f0f0;
    .element-item-right {
      display: flex;
    }
  }
`;

const UI_Item_Icon = styled.div`
  width: 24px;
  height: 24px;
`;

const UI_Item_Name = styled.div`
  flex: 1;
`;

const UI_Item_Right = styled.div`
  width: 24px;
  height: 24px;
  display: none;
`;